$(() => {
  const videoBlock = $('.c-video');
  const playBtn = $('.js-play');
  const pauseBtn = $('.js-pause');

  $('.stories__content').slick({
    prevArrow: '<button class="stories__arrow stories__arrow--prev"></button>',
    nextArrow: '<button class="stories__arrow stories__arrow--next"></button>',
    fade: true,
    dotsClass: 'stories__dots',
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 481,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  })

  let playing = false;

  function playVideo() {
    $(this).removeClass('js-unclicked');
    $(this).parent().find('video')[0].play();
    $(this).hide();
    $(this).parent().find('.c-video__title').fadeOut();
    pauseBtn.show();
    playing = true;
    onMouseEnter();
  }

  function pauseVideo() {
    $(this).parent().find('video')[0].pause();
    $(this).parent().find('.c-video__title').fadeIn();
    $(this).hide();
    playBtn.show();
    playing = false;
  }


  function onMouseEnter() {
    if (playBtn.hasClass('js-unclicked')) return;
    
  }


  function onMouseLeave() {
  }

  playBtn.on('click', playVideo);
  pauseBtn.on('click', pauseVideo);
  videoBlock.on('mouseenter', onMouseEnter);
  videoBlock.on('mouseleave', onMouseLeave);
})